import React, { useMemo } from 'react';
import './DispositionStatsStrip.css';

export default function DispositionStatsStrip({ tools }) {
  const stats = useMemo(() => {
    let critical = 0, partial = 0, complete = 0;
    for (const t of (tools || [])) {
      if (t.gap_level === 'critical') critical++;
      else if (t.gap_level === 'partial') partial++;
      else if (t.gap_level === 'complete') complete++;
    }
    return { total: (tools || []).length, critical, partial, complete };
  }, [tools]);

  return (
    <div className="dispositions-stats">
      <div className="dispositions-stat-card">
        <div className="dispositions-stat-value">{stats.total}</div>
        <div className="dispositions-stat-label">Total</div>
      </div>
      <div className="dispositions-stat-card">
        <div className="dispositions-stat-value critical">{stats.critical}</div>
        <div className="dispositions-stat-label">Critical</div>
      </div>
      <div className="dispositions-stat-card">
        <div className="dispositions-stat-value partial">{stats.partial}</div>
        <div className="dispositions-stat-label">Partial</div>
      </div>
      <div className="dispositions-stat-card">
        <div className="dispositions-stat-value complete">{stats.complete}</div>
        <div className="dispositions-stat-label">Complete</div>
      </div>
    </div>
  );
}
